import { useSearchParams, useNavigate, Link, useLocation} from "react-router-dom";
import { Card, Pagination, Collapse, Row, Col, Grid } from "antd";
import { MySegmented, MyText } from "../../components";
import { useLayoutEffect, useState, useEffect } from "react";
import { PageName, SearchContainer,ThemeMobileButton, ThemeCollapse, SearchIcon, SearchInput, SearchButton, ToggleContainer, ToggleButton, ListIcon, GridIcon, ThemeButton, ButtonContainer } from './style';
import { HeartOutlined,HeartFilled, SearchOutlined } from "@ant-design/icons";
import { fetchArticleList, fetchAutorsList } from '../../api'; 
import { AvatarIcon } from "../../assets";
import { ThemesModal } from './ThemesPopup/ThemesPopup';
import {useTranslation} from "react-i18next";
import { LeftOutlined } from "@ant-design/icons";
import {useDispatch, useSelector} from "react-redux";
import {Cookies} from "react-cookie";
import { COOKIE_KEY, fetchArticleListAction, fetchAutorsListAction, fetchSetLikeAction, fetchThemeListAction } from "../../utils";
import {fetchArticlesAction, ROUTE_PATH, selectStore} from "../../utils";
import { useEmbeddedNavigate, useEmbeddedLink } from "../../utils/context/embed";
import {Helmet} from "react-helmet";
import { useLang } from "../../utils/context/lang";

const { Panel } = Collapse;

export const ArticlesPage = () => {
  const {t, i18n} = useTranslation("common")
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const embeddedLink = useEmbeddedLink();

  const [searchParams, setSearchParams] = useSearchParams();
  const [isVertical, setIsVertical] = useState(true);
  const segmentedParams: any = searchParams.get('type');
  const pageParam: any = searchParams.get('page');
  const [articles, setArticles] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const themeList = useSelector((state: any) => state.articles.themeList);
  const themes = themeList.data || [];
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(pageParam);
  const themeParam: any = searchParams.get('theme');
  const [activeKeyTheme, setActiveKeyTheme] = useState(null);
  // const [themes, setThemes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isThemesModalVisible, setIsThemesModalVisible] = useState(false);
  const topicIdFromParams = searchParams.get('topic_id');
  const initialTopicId = topicIdFromParams ? Number(topicIdFromParams) : null;
  const [selectedSubThemeId, setSelectedSubThemeId] = useState<number | null>(initialTopicId);
  const {articles: {articles: articlesState}} = useSelector(selectStore)
  const [likedArticles, setLikedArticles] = useState<{ [key: number]: boolean }>({});
  const [likeCounts, setLikeCounts] = useState<{ [key: number]: number }>({});
  const params = new URLSearchParams(location.search);
  const initialView = params.get('view') === 'list' ? 'list' : 'grid';
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();  
  const isTablet = screens.md && !screens.xl && !screens.xxl;
  const isMobile = screens.xs;
  const articleList = useSelector((state: any) => state.articles.articleList);
  const autorsList = useSelector((state: any) => state.articles.autorsList);

  const [viewMode, setViewMode] = useState(initialView);
  const { profile: { embedData: embedDataState}} = useSelector(selectStore);

  const cookies = new Cookies()
  
  const {handleChangeLang, lang} = useLang()

  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);

  const SPECIALIST_TYPE = [
    {
      key: 'articles',
      title: `${t("articles")}`
    },
    {
      key: 'authors',
      title: `${t("authors")}`
    },
  ];

  const title = SPECIALIST_TYPE.find(item => item.key === segmentedParams)?.title;
  // useLayoutEffect(() => {
  //   if (!segmentedParams) {
  //     handleChangeSegmented(SPECIALIST_TYPE[0].key);
  //   }
  // }, []);

  const updateViewMode = (mode: 'list' | 'grid') => {
    setViewMode(mode);
    const newParams = new URLSearchParams(location.search);
    newParams.set('view', mode);
    embeddedNavigate(`${location.pathname}?${newParams.toString()}`, { replace: true });
  };

  useEffect(() => {
    if (!segmentedParams) {
      handleChangeSegmented(SPECIALIST_TYPE[0].key);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!segmentedParams) return;
    if (segmentedParams === 'articles') {
      dispatch(fetchArticleListAction({ theme_id: selectedSubThemeId, page }));
    } else if (segmentedParams === 'authors') {
      dispatch(fetchAutorsListAction({ fio: null, theme_id: selectedSubThemeId }));
    }
  }, [segmentedParams, page]);

  useEffect(() => {
    if (!articleList.success || !articleList.data) return;
    setArticles(articleList.data.list || []);
    setTotalCount(articleList.data.total_count || 0);
    setLoading(false);
  }, [articleList.success, articleList.data]);

  useEffect(() => {
    if (!autorsList.success || !autorsList.data) return;
    setAuthors(autorsList.data);
    setLoading(false);
  }, [autorsList.success, autorsList.data]);

  // useEffect(() => {
  //   const loadData = async () => {
  //     setLoading(true);
  //     try {
  //       if (segmentedParams == 'articles') {
  //         const articleList = await fetchArticleList(null, null, selectedSubThemeId, page);
  //         // dispatch (fetchArticlesAction())
  //         setArticles(articleList?.list);
  //         setTotalCount(articleList?.total_count);
  //       } else if (segmentedParams === 'authors') {
  //         const authorList = await fetchAutorsList(null, selectedSubThemeId);
  //         setAuthors(authorList);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   loadData();
  // }, [segmentedParams, page]);

const handleChangeSegmented = (value: any) => {
  const existingParams = Object.fromEntries(searchParams.entries());

  const newParams: Record<string, string> = {
    ...existingParams,
    type: value,
  };

  if (selectedSubThemeId !== null) {
    newParams.topic_id = selectedSubThemeId;
  } else {
    delete newParams.topic_id;
  }

  setSearchParams(newParams);
  setSearchTerm('');
};

  // const handleArticeSearch = async () => {
  //   setLoading(true);
  //   try {
  //     // const articleList = await fetchArticleList(searchTerm, null, null); 
  //     const articleList = await fetchArticleList(searchTerm, null, null, null); 
  //     setArticles(articleList?.list);
  //   } catch (error) {
  //     console.error('Error fetching articles:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleArticeSearch = () => {
    setLoading(true);
    dispatch(fetchArticleListAction({ header: searchTerm }));
  };

  // const handleAuthorsSearch = async () => {
  //   setLoading(true);
  //   try {
  //     const articleList = await fetchAutorsList(searchTerm); 
  //     setAuthors(articleList);
  //   } catch (error) {
  //     console.error('Error fetching articles:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleAuthorsSearch = () => {
    setLoading(true);
    dispatch(fetchAutorsListAction({ fio: searchTerm }));
  };

  const showThemesModal = () => {
    setIsThemesModalVisible(true);
  };

  const handleThemesModalOk = () => {
      setIsThemesModalVisible(false);
  };

  const handleThemesModalCancel = () => {
      setIsThemesModalVisible(false);
  };

  const handlePaginationChange = (pageNumber) => {
    setPage(pageNumber);
    setSearchParams(prevParams => {
                            prevParams.delete('page');
                            if (pageNumber !== null) {
                              prevParams.set('page', pageNumber);
                            }
                            return prevParams;
                          });
  };


  useEffect(() => {
      dispatch(fetchThemeListAction({}));
    }, []);

  useEffect(() => {
    if (!Array.isArray(articles)) return;
    const initialLikes: { [key: number]: boolean } = {};
    const initialLikeCounts: { [key: number]: number } = {};

    articles.forEach((article) => {
      initialLikes[article.id] = article.is_liked_by_user;
      initialLikeCounts[article.id] = article.like_count;
    });

    setLikedArticles(initialLikes);
    setLikeCounts(initialLikeCounts);
  }, [articles]);

  // const toggleLike = (articleId: number) => {
  //   setLikedArticles((prev) => ({
  //     ...prev,
  //     [articleId]: !prev[articleId],
  //   }));

  //   setLikeCounts((prev) => ({
  //     ...prev,
  //     [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
  //   }));
    
  //   fetchSetLike(articleId, 'article');
  // };
  const toggleLike = (articleId: number) => {
    setLikedArticles((prev) => ({
      ...prev,
      [articleId]: !prev[articleId],
    }));
    setLikeCounts((prev) => ({
      ...prev,
      [articleId]: prev[articleId] + (likedArticles[articleId] ? -1 : 1),
    }));
    dispatch(fetchSetLikeAction({ entity_id: articleId, entity_type: 'article' }));
  };

  // useEffect(() => {
  //   dispatch(fetchArticlesAction())
  // }, []);

const parentThemes = themes.filter(theme => theme.parent_id === 0);

    const handlePanelChange = (key) => {
        setActiveKeyTheme(activeKeyTheme === key ? null : key);
    };

  const handleChangeTheme = (theme: string) => {
    setSearchParams({ type: segmentedParams || 'articles', theme });
  };

  useEffect(() => {
  const topicIdFromParams = searchParams.get('topic_id');
  if (topicIdFromParams) {
    const topicId = Number(topicIdFromParams);
    setSelectedSubThemeId(topicId);

    const matchedChild = themes.find(theme => theme.id === topicId && theme.parent_id !== null);
    if (matchedChild) {
      setActiveKeyTheme(matchedChild.parent_id);
    } else {
      setActiveKeyTheme(null);
    }
  }
}, [themes]);

const handleGoBack = () => {
    embeddedNavigate('/');
  }
  const embedParam = searchParams.get('embed');

  const formatDate = (dateString, lang) => {
    const date = new Date(dateString);
    const locale = lang === 'kk' ? 'kk-KZ' : 'ru-RU';
  
    const kazakhMonths = [
      'қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым',
      'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан'
    ];
  
    const optionsDate = { year: 'numeric', month: 'long', day: 'numeric' };
    const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: false, hourCycle: 'h23' };
  
    let formattedDate = new Intl.DateTimeFormat(locale, optionsDate).format(date);
    const formattedTime = new Intl.DateTimeFormat(locale, optionsTime).format(date);
  
    if (lang === 'kk') {
      const monthIndex = date.getMonth();
      const kazakhMonth = kazakhMonths[monthIndex];
      
      formattedDate = formattedDate.replace(
        /(\d{1,2})\s[\wа-яё]+\s(\d{4})/i, 
        `$1 ${kazakhMonth} $2`
      );
    }
  
    return `${formattedDate} ${formattedTime}`.replace(/г\.\s*/, '');
  };
  

  const toggleOrientation = () => {
    setIsVertical(prev => !prev);
  };

  const handleThemesDataSubmit = (items: any[], totalCount: number) => {
  const type = searchParams.get('type');

  if (type === 'authors') {
    setAuthors(items);
    setTotalCount(totalCount);
  } else {
    setArticles(items);
    setTotalCount(totalCount);
  }
};

  const articlesColumnWidth = viewMode === 'grid' ? '100%' : '800px';
  const renderArticleCards = () => (
    <>
      <SearchContainer>
      {!isMobile && (
        <SearchIcon>
          <SearchOutlined />
        </SearchIcon>
      )}
        <SearchInput
          type="text"
          placeholder={isMobile ? `${t("search")}...` : `${t("searchByKeyword")}...`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              segmentedParams === "articles" ? handleArticeSearch() : handleAuthorsSearch();
            }
          }}
        />
        <SearchButton isMobile={isMobile} onClick={segmentedParams === 'articles' ? handleArticeSearch : handleAuthorsSearch}>
        {isMobile ? <SearchOutlined style={{ fontSize: '30px' }} /> : `${t("search")}`}
      </SearchButton>
      </SearchContainer>
  
      <div style={{
        display: isMobile ? 'flex' : (viewMode === 'grid' ? 'grid' : 'flex'),
        gridTemplateColumns:
          viewMode === 'grid'
            ? isTablet
              ? 'repeat(2, 1fr)'
              : 'repeat(3, 1fr)'
            : 'none',
        gap: '24px',
        marginTop: '24px',
        flexWrap: 'wrap',
      }}>
        {loading ? (
          <div>{t("articlesLoading")}</div>
        ) : articles.length > 0 ? (
          articles.map((article) => (
            <div key={article.id} style={{
              display: 'flex',
              marginTop: '24px',
              width: '100%',
              flexDirection: viewMode === 'grid' ? 'column' : 'row',
            }}>
              <div style={{
                width: viewMode === 'grid' ? '100%' : '240px',
                height: isTablet ? '224px' : '188px',
                borderRadius: '12px',
                overflow: 'hidden'
              }}>
                <img 
                  src={article.image}
                  alt="Article"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              </div>
              <div style={{ display: 'flex', gap: '16px', marginLeft: viewMode === 'grid' ? '0' : '24px', width: '100%', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px' }}>
                  <div style={{ display: 'flex', gap: viewMode === 'grid' ? '6px' : '8px', alignItems: 'center' }}>
                  {(likedArticles[article.id] ?? article.is_liked_by_user) ? (
                  <HeartFilled
                    style={{
                      fontSize: "16px",
                      color: "rgba(253, 99, 99, 1)",
                      cursor: "pointer",
                    }}
                    onClick={token ? () => toggleLike(article.id) : undefined}
                  />
                ) : (
                  <HeartOutlined
                    style={{
                      fontSize: "16px",
                      color: "rgba(104, 114, 125, 1)",
                      cursor: "pointer",
                      height: '24px'
                    }}
                    onClick={token ? () => toggleLike(article.id) : undefined}
                  />
                )}
                <Col>
                {likeCounts[article.id] > 0 && (
                  <MyText color="rgba(104, 114, 125, 1)" size={16} lineHeight="24px">
                    {likeCounts[article.id]}
                  </MyText>
                )}
                </Col>
                  </div>
                  <MyText color='rgba(104, 114, 125, 1)' size={16}>
                    {formatDate(article.created_at, lang)}
                  </MyText>
                </div>
                <MyText
                  color="#0A033C"
                  size={viewMode === 'grid' ? 18 : 22}
                  weight={700}
                  style={{
                    fontFamily: 'Nunito',
                    height:
                      viewMode === 'grid'
                        ? screens.xxl
                          ? '62px'
                          : '90px'
                        : 'auto',
                  }}
                >
                {/* {article.header.length > 50 ? `${article.header.slice(0, 45)}...` : article.header} */}
                {article.header}
                </MyText>
                <MyText
                  color="#0A033C"
                  size={16}
                  lineHeight={viewMode === 'grid' ? '20px' : '24px'}
                  style={{
                    fontFamily: 'Nunito',
                    height: viewMode === 'grid' ? '72px' : 'auto',
                  }}
                >
                  {(viewMode === 'grid'
                    ? article.content
                        .replace(/<\/?[a-zA-Z][^>]*>/g, '')
                        .replace(/\u00A0/g, ' ')
                        .slice(0, 90)
                    : article.content
                        .replace(/<\/?[a-zA-Z][^>]*>/g, '')
                        .replace(/\u00A0/g, ' ')
                        .slice(0, 140)
                  ) +
                    (article.content.length > (viewMode === 'grid' ? 90 : 140) ? '...' : '')}
                </MyText>
                <Link
                  to={embeddedLink(
                    `/articles/${article.id}?type=articles&view=${viewMode}` +
                      (selectedSubThemeId != null && !isNaN(selectedSubThemeId)
                        ? `&topic_id=${selectedSubThemeId}`
                        : '') +
                      (page != null && !isNaN(page) ? `&page=${page}` : '')
                  )}
                >
                <MyText color='rgba(0, 141, 210, 1)' size={20} weight={600}>                    
                    {t("moreDetails")} →
                  </MyText>
                </Link>
              </div>
            </div>
          )) 
        ) : (
          // <MyText color="#0A033C" size={screens.xs ? 16 : 18} weight={600} style={{ fontFamily: 'Nunito', lineHeight: 'auto' }}>
          //   {t("noFound")}
          // </MyText>
          <></>
        )}
      </div>
      {totalCount > 9 && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
          <Pagination defaultCurrent={1} pageSize={9} current={page} onChange={handlePaginationChange} total={totalCount} />
                </div>
              )}
    </>
  );

  const renderAuthorCards = () => (
    <>
      <SearchContainer>
        {!isMobile && (
          <SearchIcon>
            <SearchOutlined />
          </SearchIcon>
        )}
        <SearchInput
          type="text"
          placeholder={isMobile ? `${t("search")}...` : `${t("searchByKeyword")}...`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <SearchButton isMobile={isMobile}  onClick={segmentedParams === 'articles' ? handleArticeSearch : handleAuthorsSearch}>
          {isMobile ? <SearchOutlined style={{ fontSize: '30px' }} /> : `${t("search")}`}
        </SearchButton>
      </SearchContainer>
  
      <Row gutter={[24, 24]} style={{ marginTop: '24px' }}>
        {authors.map((author) => (
          <Col span={isMobile ? 24 : 12} key={author.id}>
            {/* <Link to={`/authors/${author.id}?type=authors`} style={{ textDecoration: 'none' }}> */}
            <Link
                to={embeddedLink(`/authors/${author.id}?type=authors${selectedSubThemeId != null && !isNaN(selectedSubThemeId) ? `&topic_id=${selectedSubThemeId}` : ''}`)}
                style={{ textDecoration: 'none' }}
              >
              <div style={{
                borderRadius: '12px',
                height: '93px',
                display: 'flex',
                border: '1px solid rgba(229, 233, 242, 1)',
              }}>
                <div style={{
                  width: '83px',
                  height: '63px',
                  margin: '15px',
                  borderRadius: '50%',
                  overflow: 'hidden'
                }}>
                  {author.avatar ? (
                    <img 
                      src={author.avatar}
                      alt="Author"
                      style={{
                        width: '63px',
                        height: '63px',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <AvatarIcon style={{
                      width: '63px',
                      height: '63px',
                      borderRadius: '50%',
                    }} />
                  )}
                </div>
                <div style={{ 
                  display: 'flex', 
                  width: '100%', 
                  flexDirection: 'column'
                }}>
                  <MyText color='#0A033C' size={16} lineHeight={isMobile ? '16px' : '24px'} weight={800} style={{ fontFamily: 'Nunito', marginTop: '20px' }}>
                    {author.fio}
                  </MyText>
                  <MyText color='rgba(104, 114, 125, 1)' size={14} lineHeight="24px">
                    {author.position}
                  </MyText>
                </div>
              </div>
            </Link>
          </Col>
        ))}
      </Row>
      
      {/* {totalCount > 9 && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px' }}>
          <Pagination defaultCurrent={1} pageSize={9} current={page} onChange={handlePaginationChange} total={totalCount} />
        </div>
      )} */}
    </>
  );
  

return (
<>
      <Helmet>
        <title>Статьи для родителей и педагогов</title>
        <meta name="description" content="Полезные статьи для родителей и педагогов: развитие, воспитание, обучение детей от раннего возраста до дошкольного" />
      </Helmet>

  <Row style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
    <Row justify="center">
      <Col span={20}>
      <ThemesModal
                visible={isThemesModalVisible}
                onOk={handleThemesModalOk}
                onCancel={handleThemesModalCancel}
                themes={themes}
                onDataSubmit={handleThemesDataSubmit}
                selectedSubThemeId={selectedSubThemeId}
                setSelectedSubThemeId={setSelectedSubThemeId}
            />
        <Row justify={embedDataState?.data ? 'auto' : 'space-between'} align="middle" gutter={[embedDataState?.data ? 32 : 0, 24]}>
          {( embedDataState?.data) && (
  screens.xs ? (
    <Col span={3}>
      <ButtonContainer onClick={handleGoBack}>
        <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
      </ButtonContainer>
    </Col>
  ) : (
    <ButtonContainer onClick={handleGoBack}>
      <LeftOutlined style={{ color: 'rgba(10, 3, 60, 0.7)' }} />
    </ButtonContainer>
  )
)}
  <Col>

          {/* <div style={{ marginBottom: screens.xs ? "0px" : '24px' }}> */}
            <MySegmented
              type="primary"
              options={SPECIALIST_TYPE.map(item => ({
                label: item.title,
                value: item.key
              }))}
              onChange={handleChangeSegmented}
              value={segmentedParams}
            />
          {/* </div> */}
</Col>
          <Row style={{ width: '100%' }}>
            <Col span={isMobile || isTablet ? 24 : 18}>
              <Card style={{ width: screens.xs ? '100%' : '96%', borderRadius: '20px' }}>
                <PageName>
                 <div
                    style={{
                      display: 'flex',
                      gap: '32px',
                      justifyContent: 'space-between',
                      marginBottom: '24px',
                      alignItems: 'center'
                    }}
                  >
                    <MyText
                      color="#0A033C"
                      size={screens.xs ? 24 : 32}
                      weight={800}
                      style={{ fontFamily: 'Nunito', lineHeight: 'auto' }}
                    >
                      {title}
                    </MyText>

                    <div style={{ marginLeft: 'auto', display: 'flex', gap: '12px' }}>
                      {(isMobile || isTablet) && (
                        <ThemeMobileButton isMobile={isMobile} onClick={showThemesModal}>
                          {t("topics")}
                        </ThemeMobileButton>
                      )}

                      {!isMobile && segmentedParams === 'articles' && (
                        <ToggleContainer>
                          <ToggleButton active={viewMode === 'list'} onClick={() => updateViewMode('list')}>
                            <ListIcon active={viewMode === 'list'}>
                              <div className="line"></div>
                              <div className="line"></div>
                            </ListIcon>
                          </ToggleButton>
                          <ToggleButton active={viewMode === 'grid'} onClick={() => updateViewMode('grid')}>
                            <GridIcon active={viewMode === 'grid'}>
                              <div className="grid-cell"></div>
                              <div className="grid-cell"></div>
                              <div className="grid-cell"></div>
                              <div className="grid-cell"></div>
                            </GridIcon>
                          </ToggleButton>
                        </ToggleContainer>
                      )}
                    </div>
                  </div>

                  {segmentedParams === 'articles' ? renderArticleCards() : renderAuthorCards()}
                </PageName>
              </Card>
            </Col>
          
            {!(isMobile || isTablet) && (
            <Col span={6}>
              <Card style={{ width: '100%', borderRadius: '20px' }}>
                {!isMobile && (
                  <PageName style={{ width: '100%' }}>
                  <MyText color="#0A033C" size={18} weight={800} style={{ marginBottom: '16px', fontFamily: 'Nunito' }}>
                    {t("topics")}
                  </MyText>
                  {[ { id: null, name: t("all") }, ...parentThemes ].map(parentTheme => {
                    const childThemes = parentTheme.id ? themes.filter(theme => theme.parent_id === parentTheme.id) : [];

                    return childThemes.length === 0 ? (
                      <li
                        key={parentTheme.id ?? 'all'}
                        style={{ marginBottom: '8px', cursor: 'pointer', fontSize: '18px' }}
                        // onClick={async () => {
                        //   setActiveKeyTheme(null);
                        //   setSelectedSubThemeId(parentTheme.id);
                        //   setSearchParams(prevParams => {
                        //     prevParams.delete('topic_id');
                        //     prevParams.delete('page')
                        //     if (parentTheme.id !== null) {
                        //       prevParams.set('topic_id', parentTheme.id);
                        //     }
                        //     return prevParams;
                        //   });

                        //   try {
                        //     if (segmentedParams === 'authors') {
                        //       const authorList = await fetchAutorsList(null, parentTheme.id);
                        //       setAuthors(authorList);

                        //     } else {
                        //       const response = await fetchArticleList(null, null, parentTheme.id);
                        //       setArticles(response?.list);
                        //       setTotalCount(response?.total_count);
                        //       setPage(1);
                        //     }
                        //   } catch (error) {
                        //     console.error('Error fetching content:', error);
                        //   }
                        // }}
                        onClick={() => {
                          setActiveKeyTheme(null);
                          setSelectedSubThemeId(parentTheme.id);
                          setSearchParams(prevParams => {
                            prevParams.delete('topic_id');
                            prevParams.delete('page');
                            if (parentTheme.id !== null) {
                              prevParams.set('topic_id', parentTheme.id);
                            }
                            return prevParams;
                          });

                          if (segmentedParams === 'authors') {
                            dispatch(fetchAutorsListAction({ fio: null, theme_id: parentTheme.id }));
                          } else {
                            dispatch(fetchArticleListAction({ theme_id: parentTheme.id }));
                            setPage(1);
                          }
                        }}
                      >
                        <div
                          style={{
                            background:
                              selectedSubThemeId === parentTheme.id
                                ? 'rgba(231, 250, 255, 1)'
                                : '#fff',
                            borderRadius: '8px',
                            padding: '12px',
                            border: '1px solid #d9d9d9',
                          }}
                        >
                          <MyText
                            color={
                              selectedSubThemeId === parentTheme.id
                                ? 'rgba(0, 141, 210, 1)'
                                : '#0A033C'
                            }
                            size={18}
                            weight={600}
                          >
                            {parentTheme.name}
                          </MyText>
                        </div>
                      </li>
                    ) : (
                      <ThemeCollapse
                        activeKey={activeKeyTheme}
                        onChange={handlePanelChange}
                        style={{ marginBottom: '8px', background: '#fff' }}
                        key={parentTheme.id}
                      >
                        <Panel
                          header={
                            <MyText color="#0A033C" size={18} weight={600}>
                              {parentTheme.name}
                            </MyText>
                          }
                          key={parentTheme.id}
                        >
                          <ul style={{ padding: 0, listStyleType: 'none' }}>
                            {childThemes.map(subTheme => (
                              <li
                                key={subTheme.id}
                                style={{
                                  marginBottom: '8px',
                                  cursor: 'pointer',
                                  fontSize: '18px',
                                  color:
                                    selectedSubThemeId === subTheme.id
                                      ? 'rgba(0, 141, 210, 1)'
                                      : '#0A033C',
                                }}
                                // onClick={async () => {
                                //   setSelectedSubThemeId(subTheme.id);
                                //   setSearchParams(prevParams => {
                                //     prevParams.set('topic_id', subTheme.id);
                                //     prevParams.delete('page')
                                //     return prevParams;
                                //   });

                                //   try {
                                //     if (segmentedParams === 'authors') {
                                //       const authorList = await fetchAutorsList(null, subTheme.id);
                                //       setAuthors(authorList);
                                //     } else {
                                //       const response = await fetchArticleList(
                                //         null,
                                //         null,
                                //         subTheme.id
                                //       );
                                //       setArticles(response?.list);
                                //       setTotalCount(response?.total_count);
                                //       setPage(1);
                                //     }
                                //   } catch (error) {
                                //     console.error('Error fetching content:', error);
                                //   }
                                // }}
                                onClick={() => {
                                  setSelectedSubThemeId(subTheme.id);
                                  setSearchParams(prevParams => {
                                    prevParams.set('topic_id', subTheme.id);
                                    prevParams.delete('page');
                                    return prevParams;
                                  });

                                  if (segmentedParams === 'authors') {
                                    dispatch(fetchAutorsListAction({ fio: null, theme_id: subTheme.id }));
                                  } else {
                                    dispatch(fetchArticleListAction({ theme_id: subTheme.id }));
                                    setPage(1);
                                  }
                                }}
                              >
                                {subTheme.name}
                              </li>
                            ))}
                          </ul>
                        </Panel>
                      </ThemeCollapse>
                    );
                  })}
                </PageName>
                )}
              </Card>
            </Col>
            )}
          </Row>
        </Row>
      </Col>
    </Row>
  </Row>
  </>
);
};
